// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"656":"4d36a0d95af41b9e6ee096b2d783d9ac","801":"7dd6e637cf24ad6baafb27c46f529efc"}[chunkId] + ".js";
};